import React, { useContext, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import axios from 'axios';

const Login = () => {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [isPending, setIsPending] = useState(false);
  const [showSenha, setShowSenha] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const successMessage = location.state?.successMessage || '';

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setIsPending(true);

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/users/login`, {
        email,
        senha,
      });

      login(res.data.token);
      navigate('/listas');
    } catch (err) {
      setErrorMessage(
        err.response?.data?.msg || 'Falha no login. Verifique suas credenciais.'
      );
    } finally {
      setIsPending(false);
    }
  };

  return (
    <section className="page-section auth-page">
      <div className="auth-layout">
        <div className="surface-card auth-panel">
          <span className="eyebrow">Acesso rápido</span>
          <h1 className="section-title">Entre e continue acompanhando suas compras.</h1>
          <p className="section-copy">
            Tudo o que você já organizou continua disponível com histórico,
            categorias e acompanhamento de progresso.
          </p>
          <ul className="feature-list">
            <li>Atualizações em tempo real para listas compartilhadas.</li>
            <li>Controle visual mais limpo para itens e totais.</li>
            <li>Alternância entre modo claro e escuro sem recarregar.</li>
          </ul>
        </div>

        <div className="surface-card auth-card">
          <div className="section-heading">
            <span className="eyebrow">Login</span>
            <h2 className="section-subtitle">Acesse sua conta</h2>
          </div>

          {successMessage && (
            <div className="notice notice--success" role="status">
              {successMessage}
            </div>
          )}

          {errorMessage && (
            <div className="notice notice--error" role="alert">
              {errorMessage}
            </div>
          )}

          <form onSubmit={onSubmit} autoComplete="off" className="auth-form">
            <label className="field" htmlFor="email">
              <span className="field-label">E-mail</span>
              <input
                id="email"
                type="email"
                className="field-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
                autoFocus
              />
            </label>

            <label className="field" htmlFor="senha">
              <span className="field-label">Senha</span>
              <div className="password-field">
                <input
                  id="senha"
                  type={showSenha ? 'text' : 'password'}
                  className="field-input"
                  required
                  autoComplete="current-password"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowSenha((currentState) => !currentState)}
                  aria-label={showSenha ? 'Ocultar senha' : 'Mostrar senha'}
                >
                  <i className={`bi ${showSenha ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                </button>
              </div>
            </label>

            <div className="auth-actions">
              <button
                type="submit"
                className="primary-button button-block"
                disabled={isPending}
              >
                {isPending ? (
                  <>
                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    Entrando...
                  </>
                ) : (
                  'Entrar'
                )}
              </button>
            </div>
          </form>

          <p className="auth-footer">
            Não tem uma conta?{' '}
            <Link to="/register" className="inline-link">
              Crie agora
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};
export default Login;
